// extracted by mini-css-extract-plugin
export default {"title":"CollectionsTableInput_title__UA-9E"};